import { React, useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Stack, Badge } from "react-bootstrap";
import hlogo from "../images/hlogo.jpg";
import "../styles/nav.css";
import { connect } from "react-redux";
import { logout } from "../actions/auth";
import { BsPower } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import { get_user } from "../actions/myuser";
import afromerch from "../images/afromerch.jpg";
import smartflows from "../images/smartflows.jpg";
import Birongo from "../images/birongo.png";
import { checkAuthenticated } from "../actions/auth";
import axios from "axios";
import ReconnectingWebSocket from "reconnecting-websocket";
import { FaRegBell, FaUser } from "react-icons/fa";
import { getData } from "../actions/getdata";
import moment from "moment";
import { companies } from "./assets/assets";

function Navigation({
  logout,
  isAuthenticated,
  myuser,
  checkAuthenticated,
  get_user,
}) {
  const navigate = useNavigate();
  const [mynavbar, setMynavbar] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const [company, setCompany] = useState("");
  const [socket, setSocket] = useState(null);
  const location = useLocation();
  const [tasks, setTasks] = useState([]);

  const gettasksurl = `${process.env.REACT_APP_API_URL}/finance/all_tasks`;
  useEffect(() => {
    getData(gettasksurl).then((res) => {
      setLoading(false);
      setTasks(res);
    });
  }, []);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (myuser.role == "finance") {
      const newSocket = new ReconnectingWebSocket(
        `${process.env.REACT_APP_WEBSOCKET_URL}/notification/finance`
      );

      setSocket(newSocket);
    }
  }, []);

  useEffect(() => {
    if (socket) {
      socket.addEventListener("message", (event) => {
        const data = JSON.parse(event.data);
        console.log(data);
        getData(gettasksurl).then((res) => {
          setLoading(false);
          console.log(res);
          setTasks(res);
        });
      });
    }
  }, [socket]);

  const updateCompany = async (value) => {
    setUploading((uploading) => !uploading);
    const config = {
      headers: {
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };
    const url = process.env.REACT_APP_API_URL;

    const body = { company: value };

    try {
      const res = await axios
        .patch(`${url}/ticketing/update_user`, body, config)
        .then(() => {
          setUploading((uploading) => !uploading);
          setMessage({
            ...message,
            notification: "Company Successfully Updated",
          });
        })
        .catch((err) => {
          setUploading((uploading) => !uploading);
          setMessage({
            ...message,
            notification: "Error Company Could Not be Updated",
          });
        });
    } catch (err) {
      setUploading((uploading) => !uploading);
      console.log(err);
    }
  };

  useEffect(() => {
    get_user()
      .then((res) => {})
      .catch((err) => {});
  }, [uploading]);

  useEffect(() => {
    get_user();
    checkAuthenticated()
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  return (
    <Navbar
      expand="md"
      className={"opaque-nav p-0 d-flex align-items-center m-0"}
      variant="dark"
      fixed="top"
      collapseOnSelect>
      <Navbar.Brand
        href="#"
        className="justify-content-start flex-grow-1 ps-4 ms-0">
        <img
          className={
            myuser.company === "Valent"
              ? "logonav"
              : myuser.company === "Slypeak"
              ? "afromerch"
              : myuser.company === "Birongo"
              ? "smartflows"
              : "smartflows"
          }
          src={
            myuser.company === "Slypeak"
              ? afromerch
              : myuser.company === "Valent"
              ? hlogo
              : myuser.company === "Birongo"
              ? Birongo
              : smartflows
          }
        />
      </Navbar.Brand>
      {!isAuthenticated ? (
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="me-4"
          id="navbar-toggler"
        />
      ) : (
        <>
          {isAuthenticated && myuser !== null && (
            <Nav className="me-auto pt-0">
              <Stack direction="horizontal" gap={2}>
                <select
                  className="navigation_select"
                  onChange={(event) => {
                    setCompany(event.target.value);
                  }}>
                  <option selected disabled value={""}>
                    Company
                  </option>
                  ;
                  {companies.map((company) => {
                    return <option>{company}</option>;
                  })}
                </select>
                <div className="pb-2 me-4">
                  <button
                    onClick={() => {
                      updateCompany(company)
                        .then((res) => {
                          console.log(res);
                          window.location.reload();
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }}
                    disabled={!company || uploading}
                    className="btn btn-sm btn-outline-dark me-5 navigation_button">
                    {uploading ? <>...Updating</> : <>Update</>}
                  </button>
                </div>
              </Stack>
              {myuser.role === "finance" &&
              window.location.pathname.includes("/finance") ? (
                <Stack direction="horizontal">
                  <div style={{ position: "relative" }}>
                    <FaRegBell size={25} />
                    <Badge
                      pill
                      style={{ position: "absolute", top: "-1vh" }}
                      bg="danger">
                      {tasks.length}
                    </Badge>
                  </div>
                  {tasks.length > 0 ? (
                    <NavDropdown className="no-arrow">
                      {tasks.slice(0, 5).map((task) => {
                        return (
                          <NavDropdown.Item>
                            <p>
                              {task.ticket_no ? (
                                <>Ticket {task.ticket_no}</>
                              ) : (
                                <>Ticket {task.booking_ref}</>
                              )}{" "}
                              Created on {console.log(task)}
                              {moment(task.task_time).format(
                                "HH MMM YYYY HH:MM"
                              )}
                            </p>
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                  ) : null}
                </Stack>
              ) : null}
            </Nav>
          )}
        </>
      )}
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ms-auto">
          {isAuthenticated && myuser && (
            <Nav className="pe-5 me-5 pt-0">
              {myuser.profile_pic ? (
                <div className="d-flex justify-content-center align-items-center me-2">
                  <img
                    src={`${process.env.REACT_APP_API_URL}${myuser.profile_pic}`}
                    style={{ borderRadius: "50%" }}
                    width={35}
                    height={35}
                  />
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center me-2">
                  <FaUser size={30} color="grey" />
                </div>
              )}
              <NavDropdown title={`${myuser?.first_name} ${myuser?.last_name}`}>
                <NavDropdown.Item
                  onClick={() => {
                    if (location.pathname.includes("finance")) {
                      navigate("/finance/profile");
                    } else {
                      navigate("/ticketing/profile");
                    }
                  }}>
                  <FaUser color="grey" /> My Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/"
                  onClick={() => {
                    setLoggingOut(true);
                    logout()
                      .then(() => {
                        setLoggingOut(false);
                        navigate("role");
                      })
                      .catch((err) => {
                        console.log(err);
                        setLoggingOut(false);
                        navigate("role");
                        alert.error("Something went wrong");
                      });
                  }}>
                  <BsPower /> Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  myuser: state.current_user.user,
});

export default connect(mapStateToProps, {
  logout,
  checkAuthenticated,
  get_user,
})(Navigation);
